<template>
  <div class="trend">
    <ba-trend />
  </div>
</template>

<script>
import BaTrend from '@/components/trend/Pane'

export default {
  name: 'Trend',
  components: {
    BaTrend
  }
}
</script>

<style lang="scss" scoped>
.trend {
}
</style>
